const formatDateList = (dates: string[], locale = "de-ch") => {
  const dateObjs = dates
    .map((d) => new Date(d))
    .sort((a, b) => a.getTime() - b.getTime());

  const groups: Record<string, Date[]> = {};

  for (const date of dateObjs) {
    const key = `${date.getFullYear()}-${date.getMonth()}`;
    groups[key] ??= [];
    groups[key].push(date);
  }

  const formatMonth = (date: Date) =>
    date.toLocaleDateString(locale, { month: "long" });
  const formatYear = (date: Date) =>
    date.toLocaleDateString(locale, { year: "numeric" });
  const formatDay = (date: Date) =>
    date.toLocaleDateString(locale, { day: "numeric" }) + ".";

  const result = Object.values(groups).map((datesInMonth) => {
    const days = datesInMonth.map(formatDay);

    const dayList =
      days.length === 1
        ? days[0]
        : days.length === 2
          ? `${days[0]} & ${days[1]}`
          : `${days.slice(0, -1).join(", ")} & ${days.at(-1)}`;

    const sampleDate = datesInMonth[0];
    return `${dayList} ${formatMonth(sampleDate)} ${formatYear(sampleDate)}`;
  });

  return result.join("; ");
};

export default formatDateList;
